// LUMZA operates 11:00PM – 7:00AM SAST (UTC+2, no DST).
// Window is inclusive of the 23:00 open boundary and exclusive of the 07:00 close boundary,
// so exactly 11:00PM SAST = open, exactly 7:00AM SAST = closed.

const SAST_OFFSET_MINUTES = 2 * 60;
const OPEN_MINUTE = 23 * 60;   // 11:00 PM
const CLOSE_MINUTE = 7 * 60;   // 7:00 AM
const DAY_MINUTES = 24 * 60;

export const TIMEZONE_LABEL = 'SAST';

export interface OperatingStatus {
  isOperating: boolean;
  /** Short status, e.g. "Open now", "Closed" */
  label: string;
  /** Secondary detail with SAST hint */
  detail: string;
  /** Current SAST time formatted as HH:MM */
  sastTime: string;
}

/** Minutes since SAST midnight, integer 0–1439. */
export function getSASTMinutes(now: Date = new Date()): number {
  const utcMinutes = now.getUTCHours() * 60 + now.getUTCMinutes();
  return (utcMinutes + SAST_OFFSET_MINUTES) % DAY_MINUTES;
}

function formatSAST(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function getOperatingStatus(now: Date = new Date()): OperatingStatus {
  const minutes = getSASTMinutes(now);
  // Inclusive open at 23:00, exclusive close at 07:00.
  let isOperating = minutes >= OPEN_MINUTE || minutes < CLOSE_MINUTE;

  // Dev/preview override: ?preview=open or ?preview=closed
  if (typeof window !== 'undefined') {
    const p = new URLSearchParams(window.location.search).get('preview');
    if (p === 'open') isOperating = true;
    else if (p === 'closed') isOperating = false;
  }
  const sastTime = formatSAST(minutes);

  if (isOperating) {
    return {
      isOperating: true,
      label: 'Open now',
      detail: `Delivering until 7:00 AM ${TIMEZONE_LABEL}`,
      sastTime,
    };
  }

  return {
    isOperating: false,
    label: 'Closed',
    detail: `Opens at 11:00 PM ${TIMEZONE_LABEL}`,
    sastTime,
  };
}
